import { createContext, useContext } from 'react';

export type ToastType = 'success' | 'error' | 'info' | 'warning';
export interface Toast {
  message: string;
  type: ToastType;
}

export interface ToastContextValue {
  showToast: (toast: Toast) => void;
}

export const ToastContext = createContext<ToastContextValue>({
  showToast: () => {},
});

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
